import React from 'react';
import { useCallback, useEffect, useState } from 'react';

import { initAppleLogin, isAppleSDKLoaded, loadAppleSDK } from '../../services/Apple';
import Loader from '../Loader';

import styles from './socialLogin.module.scss';

interface Props {
  clientId: string;
  scope?: string | string[];
  children: React.ReactNode;

  onSuccess(response: Apple.Authorization): void;

  onFailure?(error: Error, blocked?: boolean): void;
}

export default function AppleLoginButton(props: Props) {
  const [loading, setLoading] = useState(!isAppleSDKLoaded());
  const scope = props.scope ?? ['name', 'email'];

  const handleClick = useCallback(async () => {
    if (loading) return;
    setLoading(true);
    try {
      await initAppleLogin(props.clientId, Array.isArray(scope) ? scope.join(' ') : scope);
      const response = await window.AppleID.auth.signIn();
      props.onSuccess(response);
    } catch (error) {
      if (error?.error === 'popup_closed_by_user') {
        setLoading(false);
        return;
      }
      props.onFailure?.(error, false);
      setLoading(false);
    }
  }, [loading, props.clientId, props.scope]);

  useEffect(() => {
    return loadAppleSDK(() => {
      setLoading(false);
    });
  }, []);

  return (
    <button className={styles.apple} onClick={handleClick} type="button">
      {loading ? <Loader dotClassName="bg-white" /> : props.children}
    </button>
  );
}
